<template>
<div>
	<header class="header">
		<h2 class="dashboard-title">{{ transformedTitle }}</h2>
		<button @click="openUserModal" v-if="$route.path === '/individuals'" class="create-user-btn">Create User</button>
	</header>
</div>
</template>

<script>

export default {
	props: ['title'],
	name: "dashboardHeader",
	computed: {
		transformedTitle() {
			return this.title.charAt(0).toUpperCase() + this.title.slice(1)
		},
	},
	methods: {
		openUserModal() {
			this.$router.push({
				path: `/user/create`
			})
		}
	}
}
</script>

<style scoped lang="scss">

header.header {
	padding: 25px 45px;
	background-color: white;
	color: white;
	display: flex;
	justify-content: space-between;
	.dashboard-title {
		color: #3D4B6C;
		text-align: left;
	}
	.create-user-btn{
		border:solid  1px #3D4B6C;
	}
}
</style>
